import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Table, Modal, Form,Card,Row, Col } from 'react-bootstrap';
import { Navbar, NavDropdown } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import sage from './sage.png'; // Adjust the path based on your structure
import { Link, useHistory } from "react-router-dom";
import { var_api } from '../../constant';
import * as XLSX from "xlsx";

function RescheduleList() {
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [clients, setClients] = useState([]);
  const [paginatedUsers, setPaginatedUsers] = useState([]);
  const [showLast30DaysModal, setShowLast30DaysModal] = useState(false);
  const history = useHistory();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [filteredData, onApply] = useState([]);
  const [servicePopupShow, setServicePopupShow] = useState(false);
  const [serviceData, setServiceData] = useState([]);

  const handleGoToHome = () => {
    history.push('/sb-home');
}
  // Function to fetch data (similar to a Vue `mounted` lifecycle hook)
  useEffect(() => {
    fetchClientSummary();
  }, []);

  const fetchClientSummary = async () => {
    try {
      // const userId = localStorage.getItem('userId');
      const tokens = localStorage.getItem('token');
      const todayDate = new Date();
      const formattedStartDate = todayDate.toLocaleDateString('en-GB').replace(/\//g, '-'); // Format to DD-MM-YYYY
      const response = await axios.get(
        `${var_api}/api/booking-reschedule-details/2/${formattedStartDate}`,
        {
          headers: {
            Authorization: `${tokens}`
          }
        }
      );
      setShowLast30DaysModal(false);
      onApply(response.data); // Pass data to parent component
      handleClose(); // Close modal on successful fetch
    } catch (error) {
      console.error("Error fetching client summary:", error);
    }
  };
  const handleClose = () => {
    setShowLast30DaysModal(false);
    setStartDate('');
    setEndDate('');
};
  const fetchClients = async () => {
    try {
      const response = await axios.get('/api/clients'); // Update with your API endpoint
      setClients(response.data);
      setPaginatedUsers(response.data); // Update with pagination logic if needed
    } catch (error) {
      console.error('Error fetching clients:', error);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleCloseServicepopup = () => {
    setServicePopupShow(false);
};
const downloadCombinedExcel = () => {
  // Map filteredData to create the Appointments worksheet data
  const userWsData = filteredData.map((client, index) => ({
    No: index + 1,
    "Customer Name": client.customer_name,
    "Customer Mobile": client.customer_mobile,
    "Employee Name": client.emp_name,
    "Booking Date": client.booking_date,
    "Booking Time": client.booking_time,
    "Paid Amount": client.paid_amount,
    "Total Amount": client.total_amount,
    "Slot Time": client.slot_time,
    "Transaction ID": client.transaction_id,
    Role: client.role,
    "Is Coupon Applied": client.is_coupon ? "Coupon Applied" : "Coupon not Applied",
    "Number of Services": client.services.length,
  }));

  // Create worksheet from user data
  const userWs = XLSX.utils.json_to_sheet(userWsData);

  // Map filteredData to create the Services worksheet data
  const serviceData = filteredData.flatMap((client) =>
    client.services.map((service) => ({
      "User ID": client.user_id, // or any identifier you want
      "Service Name": service.service_name,
      "From Time": (service.from_time), // Adjust to match your service object structure
      "To Time": (service.to_time),     // Adjust to match your service object structure
      "Duration": service.duration,
      "Price": service.price,
    }))
  );

  // Create worksheet from service data
  const serviceWs = XLSX.utils.json_to_sheet(serviceData);

  // Create a new workbook and add both worksheets
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, userWs, "Appointments");
  XLSX.utils.book_append_sheet(wb, serviceWs, "Services");

  // Export the workbook to an XLSX file
  XLSX.writeFile(wb, "RescheduleList.xlsx");
};

const getFullImageUrl = (path) => {
  return `${var_api}/${path}`; // Adjust base URL as needed
};

  const goBack = () => {
    history.push('/notification'); // Go back to the previous page
  };

  const popup = (services) => {
    console.log('Show popup with services:', services); // Handle service popup display
    setServicePopupShow(true);
    setServiceData(services);
  };

  return (
    <>
    <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
    <Navbar.Brand href="#home">
        <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
    <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mx-auto">
            <Nav.Link href="#" style={{ color: "black", fontSize: "25px", letterSpacing: "2px" }}>
                Notification
            </Nav.Link>
        </Nav>
        <Nav className="ms-auto">
            <Nav.Link onClick={handleGoToHome} style={{ color: "black", fontSize: "15px" }}>
                <button className="btn" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white" }}>
                    <i className="bi bi-house"></i> Go to home
                </button>
            </Nav.Link>
        </Nav>
    </Navbar.Collapse>
</Navbar>
<br/><br/><br/><br/><br/>
<Card
                                    bg="light"
                                    text="dark"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        borderRadius: "0px",
                                        margin: "30px",
                                        backgroundColor:'rgb(164, 184, 155);'
                                    }}
                                    className="mb-2"
                                >
      <div className="header mb-4">
        <Button variant="dark" onClick={goBack} className="mb-4">
          <i className='bx bx-arrow-back'></i> Back
        </Button>
        <h2 className="mb-4">Reschedule Appointments list <span></span></h2>
        <p className="mb-4">Full list of Reschedule appointments.</p>
      </div>

      {/* Filters and sorting section */}
      <div className="filters mb-4">
        <Button variant="dark" onClick={() => setShowLast30DaysModal(true)}>Date Filter</Button>
      </div>

      {/* Calendar Popup */}
      {showCalendar && (
        <div className="calendar-popup">
          <div className="calendar-header">
            <Button onClick={() => { /* Add previous month logic */ }}>Previous</Button>
            <Button onClick={() => { /* Add next month logic */ }}>Next</Button>
          </div>
          <div className="calendar-grid">
            {/* Map days in the month here */}
          </div>
        </div>
      )}

      {/* Search box */}
      {/* <div className="d-flex justify-content-end mb-4">
        <div className="search-box">
          <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <i className="ri-search-line search-icon"></i>
        </div>
      </div> */}

      {/* Table displaying the client list */}
      <div className="live-preview">
        <div className="table-responsive">
          <Table striped bordered hover className="align-middle mb-4">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Customer Name</th>
                <th>Customer Mobile</th>
                <th>Employee Name</th>
                <th>Employee Profile Picture</th>
                <th>Booking Date</th>
                <th>Booking Time</th>
                <th>Paid Amount</th>
                <th>Total Amount</th>
                <th>Slot Time</th>
                <th>Transaction ID</th>
                <th>Role</th>
                <th>Services</th>
                <th>Coupon Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((client, index) => (
                  <tr key={client.email}>
                    <td>{index + 1}</td>
                    <td>{client.customer_name}</td>
                    <td>{client.customer_mobile}</td>
                    <td>{client.emp_name}</td>
                    <td><img src={getFullImageUrl(client.emp_profile)} className="profile-image" alt="Profile" /></td>
                    <td>{client.booking_date}</td>
                    <td>{client.booking_time}</td>
                    <td>{client.paid_amount}</td>
                    <td>{client.total_amount}</td>
                    <td>{client.slot_time}</td>
                    <td>{client.transaction_id}</td>
                    <td>{client.role}</td>
                    <td>
                      <Button variant="dark"  onClick={() => popup(client.services)}>
                        {client.services.length} Services
                      </Button>
                    </td>
                    <td className={client.is_coupon ? 'text-success' : 'text-danger'}>
                      {client.is_coupon ? "Coupon Applied" : "Coupon not Applied"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="15" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {/* Button to download the Excel file */}
        <div className="d-flex justify-content-start mb-4">
          <Button variant="dark" onClick={downloadCombinedExcel}>
            Download All Data as Excel
          </Button>
        </div>
      </div>

      {/* Last 30 Days Modal */}
      <Modal show={showLast30DaysModal} onHide={() => setShowLast30DaysModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Date Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="mb-4 d-flex justify-content-between">
          <div className="w-48">
            <Form.Group controlId="startDate">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="w-48">
            <Form.Group controlId="endDate">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Form.Group>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Row className="justify-content-end">
          <Col className="d-flex">
            <Button variant="dark" onClick={fetchClientSummary}>Apply</Button>
            <Button variant="outline-secondary" onClick={handleClose} className="ms-2">Cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
      </Modal>

      <Modal
                        show={servicePopupShow}
                        onHide={handleCloseServicepopup}
                        backdrop="static"
                        keyboard={false}
                        size='m'
                    >
                        <Modal.Header closeButton>
                            <Modal.Title> Change Referal Point Value</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ overflow: 'scroll' }}>
                            <div>
                                <Card
                                    bg="light"
                                    text="dark"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        border: "none",
                                        borderBottom: "1px solid black",
                                        borderRadius: "0px",
                                        marginTop: "10px"
                                    }}
                                    className="mb-2"
                                >
                    
               <Table striped="columns" className="scrollable-table" bg="warning"  >
               <thead>
                                            <tr>
                                            <th>S.No.</th>
            <th>Service Name</th>
            <th>From Time</th>
            <th>To Time</th>
            <th>Duration</th>
            <th>Price</th>
          
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                serviceData.map((service, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>

                                                        <td>{service.service_name}</td>
                                                        <td>{service.from_time}</td>
                                                        <td>{service.to_time}</td>
                                                            
                                                        <td>{service.price}</td>
                                                        <td>{service.duration}</td>
                                                        <td>{service.price}</td>

                                                            
                                                       
                                                            
                                                            </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>

                                    {/* Pagination Controls using react-js-pagination */}

                                </Card>
                            </div>
                        </Modal.Body>
                    </Modal>

    </Card>
    </>
  );
}

export default RescheduleList;
